import React from 'react';
import '../../styles/WhatWeDo.css';

const services = [
  {
    icon: 'bi-building-check',
    title: 'Employer of Record (EOR)',
    description: 'Hire without setting up a local entity. We handle compliance, payroll, and HR.',
  },
  {
    icon: 'bi-globe2',
    title: 'Immigration Solutions',
    description: 'End-to-end visa application, EP/DP, renewals, and expat support.',
  },
  {
    icon: 'bi-person-badge',
    title: 'Recruitment Services',
    description: 'Local & regional talent sourcing with fast turnaround and strong candidate fit.',
  },
];

export default function WhatWeDo() {
  return (
    <section className="whatwedo-section py-5">
      <div className="container text-center">
        <h2 className="section-title mb-5">What We Do</h2>
        <div className="row justify-content-center g-4">
          {services.map((service, index) => (
            <div className="col-md-4" key={index}>
              <div className="whatwedo-card shadow-sm h-100 p-4">
                <i className={`bi ${service.icon} icon`}></i>
                <h5 className="mt-3 fw-semibold">{service.title}</h5>
                <p className="text-muted">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
